// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge-marker {
  display: inline-flex;
  align-items: center;
    padding: 2px 4px;
    gap: 5px;
  background: #07345a;            /* azul oscuro */
  color: white;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(121, 121, 121, 0.25);
  font-family: "Inter", Arial, sans-serif;
  font-size: 13px;
  white-space: nowrap;
  transform-origin: center;
}
.badge-marker:hover {
  cursor: pointer;
}

/* etiqueta con el nombre */
.badge-label {
  font-weight: 600;
  padding-right: 6px;
}

/* contenedor de los tres pequeños badges */
.badge-counts {
  display: inline-flex;
  gap: 6px;
  align-items: center;
}

/* cada círculo numerado */
.badge-dot {
  min-width: 17px;
  height: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  padding: 0 6px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.25);
}

/* colores */
.badge-dot.green { background: #2ecc71; }
.badge-dot.red   { background: #e74c3c; }
.badge-dot.gray  { background: #34495e; }
.badge-dot.purple   { background: #a433d1; }
.badge-dot.yellow  { background: #da9515; }
/* pequeño "cap" redondeado al final (opcional) */
.badge-tail {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -8px; /* ajusta según cuánto quieras que “toque” el punto */
  width: 0;
  height: 0;

  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 10px solid #07345a; /* MISMO color de tu badge */
}.badge-tail-outline {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -10px;
  width: 0;
  height: 0;

  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  /* border-top: 12px solid white; */
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/components/monitor-components/AfiliationMap/styles/MapboxAfiliation.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;IACjB,gBAAgB;IAChB,QAAQ;EACV,mBAAmB,aAAa,gBAAgB;EAChD,YAAY;EACZ,kBAAkB;EAClB,+CAA+C;EAC/C,uCAAuC;EACvC,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,sCAAsC;AACxC;;AAEA,YAAY;AACZ,mBAAmB,mBAAmB,EAAE;AACxC,mBAAmB,mBAAmB,EAAE;AACxC,mBAAmB,mBAAmB,EAAE;AACxC,sBAAsB,mBAAmB,EAAE;AAC3C,qBAAqB,mBAAmB,EAAE;AAC1C,iDAAiD;AACjD;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,YAAY,EAAE,qDAAqD;EACnE,QAAQ;EACR,SAAS;;EAET,kCAAkC;EAClC,mCAAmC;EACnC,8BAA8B,EAAE,4BAA4B;AAC9D,CAAC;EACC,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,SAAS;;EAET,mCAAmC;EACnC,oCAAoC;EACpC,kCAAkC;EAClC,YAAY;AACd","sourcesContent":[".badge-marker {\r\n  display: inline-flex;\r\n  align-items: center;\r\n    padding: 2px 4px;\r\n    gap: 5px;\r\n  background: #07345a;            /* azul oscuro */\r\n  color: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 1px 2px rgba(121, 121, 121, 0.25);\r\n  font-family: \"Inter\", Arial, sans-serif;\r\n  font-size: 13px;\r\n  white-space: nowrap;\r\n  transform-origin: center;\r\n}\r\n.badge-marker:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n/* etiqueta con el nombre */\r\n.badge-label {\r\n  font-weight: 600;\r\n  padding-right: 6px;\r\n}\r\n\r\n/* contenedor de los tres pequeños badges */\r\n.badge-counts {\r\n  display: inline-flex;\r\n  gap: 6px;\r\n  align-items: center;\r\n}\r\n\r\n/* cada círculo numerado */\r\n.badge-dot {\r\n  min-width: 17px;\r\n  height: 15px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #fff;\r\n  padding: 0 6px;\r\n  box-shadow: 0 1px 2px rgba(0,0,0,0.25);\r\n}\r\n\r\n/* colores */\r\n.badge-dot.green { background: #2ecc71; }\r\n.badge-dot.red   { background: #e74c3c; }\r\n.badge-dot.gray  { background: #34495e; }\r\n.badge-dot.purple   { background: #a433d1; }\r\n.badge-dot.yellow  { background: #da9515; }\r\n/* pequeño \"cap\" redondeado al final (opcional) */\r\n.badge-tail {\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  bottom: -8px; /* ajusta según cuánto quieras que “toque” el punto */\r\n  width: 0;\r\n  height: 0;\r\n\r\n  border-left: 8px solid transparent;\r\n  border-right: 8px solid transparent;\r\n  border-top: 10px solid #07345a; /* MISMO color de tu badge */\r\n}.badge-tail-outline {\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  bottom: -10px;\r\n  width: 0;\r\n  height: 0;\r\n\r\n  border-left: 10px solid transparent;\r\n  border-right: 10px solid transparent;\r\n  /* border-top: 12px solid white; */\r\n  opacity: 0.9;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
